import React from 'react';
import LoadingPip from '../Fragments/LoadingPip';

const PageSpinnerModal = React.createClass({
    propTypes: {
        message: React.PropTypes.string,
        numberOfPips: React.PropTypes.number.isRequired,
    },

    getDefaultProps() {
        return {
            message : 'Updating your premium...',
            numberOfPips: 8,
        };
    },

    render() {
        // Load in a pip for each one desired. Theoretically allows for variable
        // number of pips to be used, though the CSS only supports 8 currently.
        let pips = [];
        for (let i = 1; i < this.props.numberOfPips; i++) {
            pips.push(
                <LoadingPip pipId={i} key={i} />
            );
        }
        return (
            <modal-container class="modal-active">
                <div id="please-wait">
                    <div id="loading-indicator-container">
                        {pips.map(function(pip) {
                            return (pip);
                        })}
                    </div>
                    <p>{this.props.message}</p>
                </div>
            </modal-container>
        );
    }
});

export default PageSpinnerModal;



/** WEBPACK FOOTER **
 ** ./src/components/Modals/PageSpinnerModal.js
 **/